module.exports = "/_next/static/images/CustomDestinations@2x-1375d26d83a38fc405819980173ec27c.png";